module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-vault-3.1481d3fa.svg";